import { render } from "./IconFavorite56px.vue?vue&type=template&id=4cd8073e"
import script from "./IconFavorite56px.vue?vue&type=script&lang=js"
export * from "./IconFavorite56px.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__